// src/SqlExport.ts
import * as Context from "effect/Context";
var SqlExport = class extends Context.Tag("@dxos/sql-sqlite/SqlExport")() {
};

export {
  SqlExport
};
//# sourceMappingURL=chunk-7SK45QTI.mjs.map
